import {Component, computed, inject} from '@angular/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MeComponent} from '@app/search/filters/filter';
import {AuthDataService} from '@services/authentication/authentication-data.service';
import {AudienceFilter} from './org.filter';
import {FavoriteFilter, OwnerFilter} from './user.filter';

@Component({
  template: `<ul class="bulletless">
    @if (false) {
      <li
        ><mat-checkbox [checked]="curatedForMe()" (change)="toggleCuratedForMe($event.checked)"
          >Curated for Me</mat-checkbox
        ></li
      >
    }
    @if (authData.me()) {
      <li
        ><mat-checkbox [checked]="ownedByMe()" (change)="toggleOwnedByMe($event.checked)">Owned by Me</mat-checkbox></li
      >
      <li
        ><mat-checkbox [checked]="myFavorites()" (change)="toggleMyFavorites($event.checked)"
          >My Favorites</mat-checkbox
        ></li
      >
    }
  </ul>`,
  standalone: true,
  imports: [MatCheckboxModule],
})
export class ResourceMeComponent extends MeComponent {
  protected authData = inject(AuthDataService);
  protected audienceFilter = inject(AudienceFilter);
  protected ownerFilter = inject(OwnerFilter);
  protected favoriteFilter = inject(FavoriteFilter);

  // Directly access the user Signal from the service
  readonly me = this.authData.me;

  readonly curatedForMe = computed(() => {
    const orgId = this.authData.relevantOrgId();
    if (!orgId) return false;

    return this.audienceFilter.selectedValues().includes(orgId);
  });

  readonly ownedByMe = computed(() => {
    const email = this.me()?.email;
    if (!email) return false;

    return this.ownerFilter.selectedValues().includes(email);
  });

  readonly myFavorites = computed(() => {
    const email = this.me()?.email;
    if (!email) return false;
    return this.favoriteFilter.selectedValues().includes(email);
  });

  toggleCuratedForMe(checked: boolean) {
    const orgId = this.authData.relevantOrgId();
    if (!orgId) return; // Cannot filter if organization ID is not loaded

    if (checked) {
      this.audienceFilter.add(orgId);
    } else {
      this.audienceFilter.remove(orgId);
    }
  }

  toggleOwnedByMe(checked: boolean) {
    const email = this.me()?.email;
    if (!email) return; // Cannot filter if user is not loaded

    if (checked) {
      this.ownerFilter.add(email);
    } else {
      this.ownerFilter.remove(email);
    }
  }

  toggleMyFavorites(checked: boolean) {
    const email = this.me()?.email;
    if (!email) return; // Cannot filter if user is not loaded

    if (checked) {
      this.favoriteFilter.add(email);
    } else {
      this.favoriteFilter.remove(email);
    }
  }
}
